export default __webpack_public_path__ + "static/media/Geico 1.fc80e039.jpg";